import { render, staticRenderFns } from "./contentCourseOrderingSection.vue?vue&type=template&id=b802ca3a&"
import script from "./contentCourseOrderingSection.vue?vue&type=script&lang=js&"
export * from "./contentCourseOrderingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports